import { createSelector } from "reselect"
import { find, last, chain, pick, remove } from "lodash"
import { computeData } from "modules/analyze-composite-risk/selectors/data"
import { isSegmentFilter } from "modules/analyze-composite-risk/selectors/items"
import { getSelectedContributorCategoryId } from "helpers/compositeSecuritiesDetails"

const getSelectedDate = (_, props) => props.selectedDate
const getShowSegment = (_, props) => props.showSegment
const getAllCategoryItems = (_, props) => props.allCategoryItems
const getRisk = (_, props) => props.risk

const getContributorData = createSelector(
  [getAllCategoryItems, getRisk],
  (items, risk) => computeData(items, risk),
)

const getLastContributor = createSelector(
  [getContributorData],
  (data) => last(data),
)

export const getSelectedContributorCategory = createSelector(
  [getSelectedContributorCategoryId, getAllCategoryItems, getShowSegment],
  (selectedId, items, showSegment) => {
    if (!selectedId) {
      return selectedId
    }

    const found = find(items, d => d.id === selectedId)
    if (found && (!showSegment || (showSegment && selectedId !== "total"))) {
      return found
    }
    return null
  },
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor, getShowSegment],
  (data, date, items, lastContributor, showSegment) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format("YYYY-MM-DD")) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format("YYYY-MM-DD"))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    const rows = chain(items)
      .map(item => ({
        ...pick(item, ["label", "categoryLabel", "id", "color", "favorite", "field", "isAggregated"]),
        value: dayData[item.id],
      }))
      .filter(item => Number.isFinite(item.value) || item.favorite)
      .value()
    if (!showSegment) {
      remove(rows, isSegmentFilter)
      return rows
    }

    return rows
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  (contributors, selected) => {
    if (!selected) {
      return 0
    }

    const item = find(contributors, d => d.id === selected.id)
    if (item) {
      return item.value
    } else {
      return 0
    }
  },
)
